import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Routes } from 'react-router-dom';

import { routes } from './data';
import { EmailUnverifiedRoute } from './EmailUnverifiedRoute';
import { EmptyTenantRoute } from './EmptyTenantRoute';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import { SimpleRoute } from './SimpleRoute';

import { AuthActions, AuthThunks, useAuth } from '@/features/auth';

// config url routes
export enum Screens {
    Login = '/auth/login',
    Signup = '/auth/signup',
    ForgotPassword = '/auth/forgot-password',
    ResetPassword = '/auth/reset-password',
    EmailUnverified = '/auth/email-unverified',
    Tenant = '/auth/tenant',
    Home = '/',
    Dashboard = '/dashboard',
    Settings = '/settings',
    Messages = '/messages'
}

export const RoutesComponent = () => {
    const dispatch = useDispatch();
    const { user, tenant } = useAuth();

    useEffect(() => {
        dispatch(AuthThunks.getUserAuthInfo());
    }, [dispatch]);
    return (
        <Routes>
            {routes.publicRoutes.map((route) => (
                <PublicRoute key={route.path} exact path={route.path} element={route.element} />
            ))}

            {routes.emailUnverifiedRoutes.map((route) => (
                <EmailUnverifiedRoute key={route.path} exact path={route.path} element={route.element} />
            ))}

            {routes.emptyTenantRoutes.map((route) => (
                <EmptyTenantRoute key={route.path} exact path={route.path} element={route.element} />
            ))}

            {routes.privateRoutes.map((route) => (
                <PrivateRoute key={route.path} path={route.path} element={route.element} permissionRequired={route.permissionRequired} />
            ))}

            {routes.simpleRoutes.map((route) => (
                <SimpleRoute key={route.path} path={route.path} element={route.element} />
            ))}
        </Routes>
    );
};
